import axios from "axios";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TokenDetails from "../../../components/useUserDetails/useTokenDetails";
import * as Actions from "../../../constants/baseUrl";
import "./style.css";

const ChangePassword = () => {
  const navigate = useNavigate();

  const tokenDetails = TokenDetails();
  const myUserId = tokenDetails?.Email;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      event.currentTarget["old-password"].value ===
      event.currentTarget["new-password"].value
    ) {
      axios
        .post(`${Actions.AUTH_URL}Users/change-password`, {
          email: myUserId,
          password: event.currentTarget["old-password"].value,
          newPassword: event.currentTarget["new-password"].value,
        })
        .then((res) => {
          toast.success(res.data);
          navigate("/my-profile");
        });
    } else {
      toast.error("Password and repeat password must be same");
    }
  };
  return (
    <div className="my-5 pt-5 demosAddFormSection">
      <div className="formWrap row mx-0 mt-5">
        <Form
          onSubmit={handleSubmit}
          className="col-lg-6 col-md-10 demosAddForm"
        >
          <div className="col-12 demosAddFormHeasder text-center py-3">
            <h3 className="addFormHeading" id="tabelLabel">
              Change Password
            </h3>
            <h6 className="theme-text-2">
              Fill the form below to change your password.
            </h6>
          </div>
          <Form.Group className="form-floating formfloating my-3 mx-2">
            <Form.Control
              className="form-control fromcontrol"
              type="password"
              id="old-password"
              label="Old Password"
              placeholder="Old Password"
              required
            ></Form.Control>
            <Form.Label htmlFor="old-password">Old Password</Form.Label>
          </Form.Group>
          <Form.Group className="form-floating formfloating mb-3 mx-2">
            <Form.Control
              className="form-control fromcontrol"
              type="password"
              id="new-password"
              label="New Password"
              placeholder="New Password"
              required
            ></Form.Control>
            <Form.Label htmlFor="new-password">New Password</Form.Label>
          </Form.Group>

          <Button className="btn add-button px-4 float-end mb-3" type="submit">
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
